<template>
    <Page title=" ">
        <o-loading active v-if="loading"/>

      <div class="columns is-centered">
          <div class="column is-half">

              <div class="box" v-if="accessRequestSent">
                  <div class="field">
                      <p>An access code has been sent. Please check your email and enter the access code below to view the project.</p>
                      <o-field label="Access Code*"
                               :variant="error('access_code') ? 'danger' : ''"
                               :message="error('access_code')"
                      >
                        <o-input v-model="accessCode" required></o-input>
                      </o-field>
                      <div class="controls">
                          <div class="button is-primary is-block" @click="handleAccessCode">
                              Submit
                          </div>
                      </div>
                  </div>
              </div>

              <div class="box" v-else>
                  <div class="field">
                      <p>To access this project, you'll need to verify your identity with an access code. Please enter the email address you used to receive your invitation.</p>
                      <o-field label="Email*"
                               :variant="error('email') ? 'danger' : ''"
                               :message="error('email')"
                      >
                        <o-input v-model="email" required></o-input>
                      </o-field>
                      <div class="controls">
                          <div class="button is-primary is-block" @click="handleRequestMagicLink">
                              Request Access
                          </div>
                      </div>
                  </div>
              </div>

            </div>
        </div>

    </Page>
</template>

<script setup lang="ts">

import Page from "@/components/Page.vue";
import {computed, ref} from "vue";
import {NotificationError} from "@/internal";
import {useRoute} from "vue-router";
import {useRouter} from "vue-router";
import ProjectAPI from "@/api/ProjectAPI";

const route = useRoute();
const router = useRouter();
const accessCode = ref<String | null>(null);
const email = ref<String | null>(null);
const errors = ref(<any>[]);
const loading = ref<boolean>(false);
const accessRequestSent = ref<boolean>(false);

const projectId = computed(() => parseInt(route.params.projectId as string));
const projectShowRouteName = computed(() => String(route.name).startsWith('projects/past')
  ? 'projects/past/show'
  : 'projects/show');
const projectShowRoute = computed(() => router.resolve({
  name: projectShowRouteName.value,
  params: {projectId: projectId.value},
}));

function clearErrors() {
  errors.value = [];
}

function error(key: string) {
  return errors.value?.find((error: any) => error.hasOwnProperty('key') && error.key === key)?.detail || null;
}

function handleAccessCode() {

  clearErrors();

  const payload : any = {
    access_code: accessCode.value,
    email: email.value,
  };

  loading.value = true;

  new ProjectAPI().accessCode(projectId.value, payload)
      .then((response: any) => {
        window.sessionStorage.setItem("uuid", response.uuid);

        router.push({
          name: projectShowRouteName.value,
          params: {projectId: projectId.value},
        });
      }).catch((error: any) => {
    if (error.hasOwnProperty('errors')) {
      errors.value = error.errors;
    }
    else {
      NotificationError({
        message: error,
      });
    }
  }).finally(() => {
    loading.value = false;
  });

}

function handleRequestMagicLink() {

  clearErrors();

  const payload : any = {
    redirect_url: `${window.location.origin}${projectShowRoute.value.href}`,
    email: email.value,
  };

  loading.value = true;

  new ProjectAPI().requestAccess(projectId.value, payload)
      .then((response: any) => {
        accessRequestSent.value = true;
      }).catch((error: any) => {
        if (error.hasOwnProperty('errors')) {
          errors.value = error.errors;
        }
        else {
          NotificationError({
            message: error,
          });
        }
      }).finally(() => {
        loading.value = false;
      });
}

</script>

<style lang="scss" scoped>

</style>
